module.exports = __webpack_public_path__ + "static/natural.f1a5b89b.png";